export default "__VITE_ASSET__VzLFhmtB__"